import { Injectable } from '@angular/core';
import { Widget, WidgetSunstudy, WidgetSunstudyView } from '../models/widget';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class SunstudyService {

  constructor(private http: HttpClient) {
  }

  update(sunstudy: WidgetSunstudy, data: any): Observable<WidgetSunstudy> {
    let body = JSON.stringify(data);
    return this.http.put(`${sunstudy.url}`, body)
      .pipe(map(json => new WidgetSunstudy(json)));
  }

  createView(sunstudy: WidgetSunstudy, data: any): Observable<WidgetSunstudyView> {
    let body = JSON.stringify(data);
    return this.http.post(`${sunstudy.url}/views`, body)
      .pipe(map(json => new WidgetSunstudyView(json)));
  }

  updateView(view: WidgetSunstudyView): Observable<WidgetSunstudyView> {
    let body = view.toJson();
    return this.http.put(`${view.url}`, body)
      .pipe(map(json => new WidgetSunstudyView(json)));
  }

  getView(sunstudy: WidgetSunstudy, id: number): Observable<WidgetSunstudyView> {
    return this.http.get(`${sunstudy.url}/views/${id}`)
      .pipe(map(json => new WidgetSunstudyView(json)));
  }

  deleteView(view: WidgetSunstudyView): Observable<void> {
    return this.http.delete(`${view.url}`, { responseType: 'text' })
      .pipe(map(json => null));
  }

  deleteViewFiles(view: WidgetSunstudyView): Observable<void> {
    return this.http.delete(`${view.url}/files`, { responseType: 'text' })
      .pipe(map(json => null));
  }


  create(widget: Widget, data: any): Observable<WidgetSunstudy> {
    let body = JSON.stringify(data);
    return this.http.post(`${widget.url}/sunstudies`, body)
      .pipe(map(json => new WidgetSunstudy(json)));
  }

  delete(sunstudy: WidgetSunstudy): Observable<void> {
    return this.http.delete(`${sunstudy.url}`, { responseType: 'text' })
      .pipe(map(response => null));
  }

  get(widget: Widget): Observable<WidgetSunstudy[]> {
    return this.http.get<any>(`${widget.url}/sunstudies`)
      .pipe(map(json => json.data.map(r => new WidgetSunstudy(r))));
  }
}





// WEBPACK FOOTER //
// ./src/app/widgets/sunstudy.service.ts